// extracted by mini-css-extract-plugin
module.exports = {"text":"SavedFilter_text__1J6nm","savedFiltersTags":"SavedFilter_savedFiltersTags__3iGW5","tag":"SavedFilter_tag__3oYv8","textTag":"SavedFilter_textTag__3y7qa"};